import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINTS } from '@app/constant/api.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserHoldingsService {

  constructor(
    private http: HttpClient
  ) { }

  holdings(query?): Observable<any> {
    if (query) {
      return this.http.get(
        `${API_END_POINTS.INVESTOR_LONGTERM.holdings}?${query}`
      );
    } else {
      return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.holdings}`);
    }
  }

  holdingsById(id: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.holdings}/${id}`);
  }

  subscribedFilterList(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.holdingsFilter)
  }

  dashboardStats(id?): Observable<any> {
    if (id) {
      return this.http.get(
        `${API_END_POINTS.INVESTOR_LONGTERM.dashboard_stats}/${id}`
      );
    } else {
      return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.dashboard_stats);
    }
  }

  subscriptionById(id: string): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.INVESTOR_LONGTERM.subscribe}/${id}`
    );
  }

  getTransactionData(query?): Observable<any> {
    if (query) {
      return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.holding_transactions}?${query}`)
    } else {
      return this.http.get(API_END_POINTS.INVESTOR_LONGTERM.holding_transactions)
    }
  }

  mfFilter(): Observable<any> {
    return this.http.get(API_END_POINTS.MUTUALFUND.filter_list)
  }

  getXsipInvestment(query: any): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.MUTUALFUND.xsipInvestment}?${query}`
    );
  }
  getXsipInvestmentById(id: any): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.MUTUALFUND.xsipInvestment}/${id}`
    );
  }
  getXsipOrderHistory(query: any): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.MUTUALFUND.xsipOrderHistory}?${query}`
    );
  }
  getXsipOrderHistoryById(id: any): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.MUTUALFUND.xsipOrderHistory}/${id}`
    );
  }

  sipStatus(): Observable<any> {
    return this.http.get(`${API_END_POINTS.MUTUALFUND.sipmandeteStatus}`);
  }

  mandeteLink(): Observable<any> {
    return this.http.get(`${API_END_POINTS.MUTUALFUND.mandeteLink}`);
  }

  updateTransaction(transactionID: string, data: any): Observable<any> {
    return this.http.put(`${API_END_POINTS.INVESTOR_LONGTERM.update_transaction}/${transactionID}`, data)
  }

  deleteTransaction(transactionID: string): Observable<any> {
    return this.http.delete(`${API_END_POINTS.INVESTOR_LONGTERM.update_transaction}/${transactionID}`)
  }
  brokrageHoldings(): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.brokerage_holdings}`);
  }
  getInvestpackHoldings(): Observable<any>{
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.investpack_holdings}`)
  }
}
